// @ts-nocheck
import { addToChainBefore } from "@toolkit/Modules/client-framework/HandlerCreator";
import { CallUpdateAccount, chain } from "@insite/client-framework/Store/Pages/UserSetup/Handlers/SaveUser";
import { saveUserSetupProductSets } from "@store/Framework/Services/Components/UserSetupProductSets/UserSetupProductSetsService";

addToChainBefore(chain, CallUpdateAccount, async props => {
    const state = props.getState();
    await saveUserSetupProductSets({
        accountId: props.apiParameter.account.id,
        setsIds: state.store.components.userSetupProductSets.setsIds,
    });
});
